import { useTranslations } from "next-intl";
import { NextSeo } from "next-seo";

import type { CentraOrder } from "@/lib/centra/selection/selectionFormatter";

import GiftCardItem from "../GiftCardItem";
import styles from "./order-info.module.css";
interface OrderInfoProps {
  paymentdata: CentraOrder;
}

const OrderInfo = ({ paymentdata }: OrderInfoProps) => {
  const data = paymentdata;
  const t = useTranslations();
  return (
    <>
      <NextSeo nofollow={true} noindex={true} />
      <div className={styles.grid}>
        <h1 className={styles.title}>{t("orderSummary")}</h1>
        <div className={styles.orderInfo}>
          <div className={styles.orderSummary}>
            <p>
              {t("thankYouForYourOrder")} {data?.address?.firstName}!{" "}
            </p>
            <em>
              {t("aGiftCardHasBeenSent")} {data?.address?.email}
            </em>
          </div>
          {data?.address && (
            <div className={styles.orderDetails}>
              <h3 className={styles.subTitle}>{t("shippingInfo")}</h3>
              <p>
                {data?.address?.firstName} {data?.address?.lastName}
              </p>
              <p>{data?.address?.email}</p>
              <p>{data?.address?.phoneNumber}</p>
              <p>{data?.address?.address1}</p>
              <p>{data?.address?.address2}</p>
              <p>
                {data?.address?.zipCode}, {data?.address?.city},{" "}
                {data?.address?.country}
              </p>
            </div>
          )}
          {data?.order && (
            <div className={styles.orderDetails}>
              <h3 className={styles.subTitle}>{t("orderInfo")}</h3>
              <p>Order number: {data.order}</p>
              <p>Order date: {data.date}</p>
              <p>Order status: {data.statusDescription}</p>
            </div>
          )}
          <div className={styles.orderItems}>
            <GiftCardItem item={paymentdata?.items?.[0]} />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderInfo;
